import React, { useState } from "react";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import Collapse from "@mui/material/Collapse";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

const basePath = "https://cdlschool.com";

const menuItems = [
  {
    title: "Truck Driving Classes",
    links: [
      { path: `${basePath}/cdl-training`, label: "All Classes" },
      { path: `${basePath}/cdl-training/eldt-training`, label: "ELDT Training" },
      { path: `${basePath}/cdl-training/cdl-class-a-training`, label: "CDL Class A" },
      { path: `${basePath}/cdl-training/cdl-class-b-training`, label: "CDL Class B" },
      { path: `${basePath}/cdl-training/hazmat-endorsement`, label: "Hazmat Endorsement" },
      { path: `${basePath}/troops-into-transportation`, label: "Programs for Veterans" },
    ],
  },
  {
    title: "CDL FAQ",
    links: [
      { path: `${basePath}/cdl-faq`, label: "All CDL FAQ" },
      { path: `${basePath}/cdl-faq/why-become-truck-driver`, label: "Why Become a Truck Driver" },
      { path: `${basePath}/cdl-faq/how-to-become-a-truck-driver`, label: "How to Become a Truck Driver" },
      { path: `${basePath}/cdl-faq/cdl-career-opportunities`, label: "CDL Career Opportunities" },
      { path: `${basePath}/cdl-faq/financial-aid`, label: "Financing Your CDL Training" },
    ],
  },
  {
    title: "Career Services",
    links: [
      { path: `${basePath}/career-services/job-placement`, label: "Job Placement" },
      { path: `${basePath}/career-services/carrier-partners`, label: "Carrier Partners" },
    ],
  },
  {
    title: "About Us",
    links: [
      { path: `${basePath}/about`, label: "Why the CDL Schools" },
      { path: `${basePath}/about/careers`, label: "Join Our Team" },
      { path: `${basePath}/about/locations`, label: "Locations" },
      { path: `${basePath}/about/solutions-for-employers`, label: "Employer Solution" },
    ],
  },
];

export default function NestedList() {
  const [openItems, setOpenItems] = useState({});

  const handleClick = (index) => {
    setOpenItems((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div className="accordion-wrap">
      <List sx={{ width: "100%", maxWidth: 360, bgcolor: "background.paper" }} component="nav">
        {menuItems.map((item, index) => (
          <div key={index}>
            <ListItemButton onClick={() => handleClick(index)}>
              <ListItemText primary={item.title} className="list-name"/>
              {openItems[index] ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>

            <Collapse in={openItems[index]} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                {item.links.map((link, linkIndex) => (
                  <a key={linkIndex} href={link.path} target="_blank" rel="noopener noreferrer" className="link">
                    <ListItemButton sx={{ pl: 4 }}>
                      <ListItemText primary={link.label} />
                    </ListItemButton>
                  </a>
                ))}
              </List>
            </Collapse>
          </div>
        ))}
      </List>
    </div>
  );
}
